import {Component, Input, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal, NgbNavModule} from '@ng-bootstrap/ng-bootstrap';
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {VerifyAccountComponent} from './verify-account/verify-account.component';
import {CommonConstants} from "@coreConstant";
import {UpdatePasswordComponent} from "./update-password/update-password.component";

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [NgbNavModule, LoginComponent, RegisterComponent, ForgotPasswordComponent, ResetPasswordComponent, VerifyAccountComponent, UpdatePasswordComponent],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AuthComponent {
  active = 1;
  type: any = 'login';
  @Input() authModel!: any;

  constructor(
    protected activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
    this.type = this.authModel ? this.authModel : this.type;
    if (this.authModel == CommonConstants.AUTH_MODAL_TYPES.REGISTER) {
      this.active = 2;
    }
  }
}
